__webpack_require__.S = {};
var initPromises = {};
var initTokens = {};
__webpack_require__.I = function(name, initScope) {
	if(!initScope) initScope = [];
	// handling circular init calls
	var initToken = initTokens[name];
	if(!initToken) initToken = initTokens[name] = {};
	if(initScope.indexOf(initToken) >= 0) return;
	initScope.push(initToken);
	// only runs once
	if(initPromises[name]) return initPromises[name];
	// creates a new share scope if needed
	if(!__webpack_require__.o(__webpack_require__.S, name)) __webpack_require__.S[name] = {};
	// runs all init snippets from all modules reachable
	var scope = __webpack_require__.S[name];
	var warn = function(msg) {
		if (typeof console !== "undefined" && console.warn) console.warn(msg);
	};
	var uniqueName = "reactroot-legacy";
	var register = function(name, version, factory, eager) {
		var versions = scope[name] = scope[name] || {};
		var activeVersion = versions[version];
		if(!activeVersion || (!activeVersion.loaded && (!eager != !activeVersion.eager ? eager : uniqueName > activeVersion.from))) versions[version] = { get: factory, from: uniqueName, eager: !!eager };
	};
	var initExternal = function(id) {
		var handleError = function(err) { warn("Initialization of sharing external failed: " + err); };
		try {
			var module = __webpack_require__(id);
			if(!module) return;
			var initFn = function(module) { return module && module.init && module.init(__webpack_require__.S[name], initScope); }
			if(module.then) return promises.push(module.then(initFn, handleError));
			var initResult = initFn(module);
			if(initResult && initResult.then) return promises.push(initResult['catch'](handleError));
		} catch(err) { handleError(err); }
	}
	var promises = [];
	switch(name) {
		case "default": {
			register("react-dom", "18.2.0", function() { return Promise.all([__webpack_require__.e("vendor-_yarn___virtual___react-dom-virtual-8da4c5617b_0_cache_react-dom-npm-18_2_0-dd675bca1c-894f85"), __webpack_require__.e("webpack_sharing_consume_default_react_react-_7bcb")]).then(function() { return function() { return __webpack_require__(18136); }; }); });
			register("react-dom", "18.2.0", function() { return Promise.all([__webpack_require__.e("vendor-_yarn___virtual___react-dom-virtual-f9c5e9f4fd_0_cache_react-dom-npm-18_2_0-dd675bca1c-01788a"), __webpack_require__.e("webpack_sharing_consume_default_react_react-_7bcb")]).then(function() { return function() { return __webpack_require__(22902); }; }); });
			register("react-i18next", "15.7.4", function() { return Promise.all([__webpack_require__.e("vendor-_yarn___virtual___react-i18next-virtual-5a12ef0a6e_0_cache_react-i18next-npm-15_7_4-b3-6710e2"), __webpack_require__.e("webpack_sharing_consume_default_react_react-_798f")]).then(function() { return function() { return __webpack_require__(7984); }; }); });
			register("react-i18next", "15.7.4", function() { return Promise.all([__webpack_require__.e("vendor-_yarn___virtual___react-i18next-virtual-779400bfed_0_cache_react-i18next-npm-15_7_4-b3-138ed4"), __webpack_require__.e("webpack_sharing_consume_default_react_react-_798f")]).then(function() { return function() { return __webpack_require__(98718); }; }); });
			register("react", "18.2.0", function() { return __webpack_require__.e("react-_yarn_cache_react-npm-18_2_0-1eae08fee2-b9214a9bd7_zip_node_modules_react_index_js").then(function() { return function() { return __webpack_require__(48527); }; }); });
		}
		break;
	}
	if(!promises.length) return initPromises[name] = 1;
	return initPromises[name] = Promise.all(promises).then(function() { return initPromises[name] = 1; });
};